import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { ThemeContext } from '../../../module/ThemeManager';
import { Box, Container } from '@mui/material';
import { LoginHeader } from '../../Header/EsLoginHeader';
import { ColorScheme, theme } from '../../../constants/theme';
import { EsLoginForm } from '../../EsLoginForm/EsLoginForm';
import { TUsernamePassword } from '../../EsLoginForm/EsSigninData';
import { Spotlight } from '../../Spotlight/Spotlight';
import { AnimationBackground } from '../../Spotlight/AnimationBackground';

interface ILogin {
    onSubmit: (data: TUsernamePassword, callBack?: () => void, isLastStep?: boolean) => void;
    onResendOtp: (data: TUsernamePassword) => Promise<unknown>;
    loading?: boolean;
    otpLoading?: boolean;
    resendInProgress?: boolean;
    loginMessage?: string;
    loginChannel?: 'sms' | 'whatsapp' | 'audme' | 'email';
    audmeData?: {
        token?: string;
        qrCode?: string;
        deeplink?: string;
    } | null;
}

const EsLoginContainer: React.FC<ILogin> = ({
    onSubmit,
    onResendOtp,
    loading,
    otpLoading,
    resendInProgress,
    loginMessage,
    loginChannel,
    audmeData,
}) => {
    const [showBg] = useState(true);

    return (
        <ThemeContext.Consumer>
            {({ themeStyle, darkModeEnabled }) => {
                const styles = dynamicStyles(themeStyle);

                return (
                    <View
                        style={{
                            ...styles.container,
                            ...(darkModeEnabled && {
                                backgroundImage: `linear-gradient(to bottom, ${theme[themeStyle].true_black} 0%, ${theme[themeStyle].true_white} 500%)`,
                            }),
                            ...(!darkModeEnabled && {
                                backgroundColor: theme[themeStyle].tag_white_light,
                            }),
                        }}>
                        {/* <EsBackground /> */}
                        <LoginHeader />
                        <Spotlight withoutBg={!showBg} />

                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                flexDirection: 'row',
                            }}>
                            <Container
                                sx={{
                                    zIndex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                <EsLoginForm
                                    onSubmit={(data, cb, isLastStep) => onSubmit(data, cb, isLastStep)}
                                    onResendOtp={onResendOtp}
                                    loading={loading}
                                    otpLoading={otpLoading}
                                    resendInProgress={resendInProgress}
                                    loginMessage={loginMessage}
                                    loginChannel={loginChannel}
                                    audmeData={audmeData}
                                    formStyle={{ maxHeight: '700px' }}
                                />
                            </Container>

                            {showBg && <AnimationBackground />}
                        </Box>
                    </View>
                );
            }}
        </ThemeContext.Consumer>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        container: {
            width: '100vw',
            height: '100vh',
            minHeight: '100vh',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        },
    });
export { EsLoginContainer };
